import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from "lodash";
import { ForwardButton, BackButton, DisplayErrors } from "./Survey.jsx";
import { Trans } from 'react-i18next';

class MultipleChoiceQuestion extends Component {
    constructor(props) {
        super(props);

        //Allows use of state and this in the handlechange function
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.localValidation = debounce(this.localValidation.bind(this), 500);
        this.loadSurvey = this.loadSurvey.bind(this);
        this.checkResponseSelected = this.checkResponseSelected.bind(this);

        this.state = {
            error: false,
            response: {}
        };
    }

    componentDidMount() {
        var self = this;
        var response = self.state.response;

        if(self.props.responses.length > 0)
        {
            response = {question_id: self.props.question.Id, "answer": self.props.responses[0].Response_Choice_Id};

            self.setState({
                response: response
            });
        }
    }

    localValidation(e, props) {
        var self = this;
        var response = self.state.response;

        if($("#required_" + props.question.Id).val() === "true") // check if question is required
        {
            if(jQuery.isEmptyObject(response))
            {
                var error = true;

                self.setState({
                    error: error
                });

                return;
            }
        }

        if(!this.state.error)
        {
            var response2 = response;

            if(jQuery.isEmptyObject(response))
            {
                response2 = {question_id: self.props.question.Id, "answer": null};
            }

            props.handleResponse(e, props, response2);
        }
    }

    loadSurvey(e, props, action) {
        props.loadSurvey(e, props, action);
    }

    onChangeHandler(e, props) {
        var self = this;
        var error = false;
        var response = self.state.response;

        if(e.target.checked) {
            response = {question_id: self.props.question.Id, "answer": parseInt(e.target.value)};
        }

        self.setState({
            error: error,
            response: response
        });
    }

    checkResponseSelected(response, option, value) {
        var string = "";

        if(!jQuery.isEmptyObject(response)) {
            if(response.answer == parseInt(option.Id)) {
                string = value;
            }
        }

        return string;
    }
    
    render() {
        return (
            <>
                <div className="registration-main">
                    <div className={"survey-questions-container question-" + (this.props.page)}>
                        <div className="survey-question-text">{ this.props.question.Text }</div>
                        <div className="survey-question-selectbox">
                            <div className = "multiple-choice">
                                <div className={"row checkbox-row " + (this.state.error ? "checkbox-error" : "")}>
                                    { this.props.options.map((option) => 
                                        <label className={this.checkResponseSelected(this.state.response, option, 'checked')} key={"multiple-choice-" + option.Id}>
                                            <span className = "radio-text">{ option.Text }</span>
                                            <input type="radio" name="answer[]" key={"answer_for_" + this.props.question.Id} id={"answer_" + option.Id } value={ option.Id } className="form-control input-sm multiple-choice-radio" defaultChecked={this.checkResponseSelected(this.state.response, option, 'checked')} onChange={(e) => this.onChangeHandler(e, this.props)}/>
                                            <span className="checkmark"></span>
                                        </label>
                                    ) }
                                </div>
                            </div>
                            <div className="help-text">{ this.props.question.Help_Text }</div>
                            <input type='hidden' name={'required_' + this.props.question.Id} id={'required_' + this.props.question.Id} value={ (this.props.question.Validation).includes("required") ? true : false }/>
                        </div>
                    </div>
                </div>

                <div className="registration-actions">
                    {
                        this.props.question.question_orders.length == 0 || this.props.question.question_orders[0].Question_Order != 1 ?
                            <div className="registration-left">
                                <span onClick={(e) => this.loadSurvey(e, this.props, 'previous')} className="primary medium">
                                    <i className="fas fa-arrow-left" style={{marginRight: "20px"}}></i>
                                    <span><Trans>Back</Trans></span>
                                </span>
                            </div>
                        :
                            null
                    }
                    <div className="registration-right">
                        <span onClick={(e) => this.localValidation(e, this.props)} className={"primary medium registration-button " + ((this.props.question.Validation).includes("required") && (jQuery.isEmptyObject(this.state.response) || this.state.response.answer.length == 0) ? "disabled" : "registration-active")} style={{marginLeft: "20px"}}>
                            <span><Trans>Next</Trans></span>
                            <i className="fas fa-arrow-right" style={{marginLeft: "40px"}}></i>
                        </span>
                    </div>
                </div>
            </>
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(MultipleChoiceQuestion);